module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jHi4U"))).then(() => parcelRequire('hEqeo'));